import React, { useState } from 'react';
import { Card } from '../../components/ui/card';
import { Label } from '../../components/ui/label';
import { Switch } from '../../components/ui/switch';
import { Button } from '../../components/ui/button';
import { Eye, EyeOff, Shield } from 'lucide-react';
import { toast } from '../../hooks/use-toast';

const Privacy = () => {
  const [settings, setSettings] = useState({
    profileVisible: true,
    showEmail: false,
    showPhone: false,
    showPurchaseHistory: true,
    allowMessages: true,
    showOnlineStatus: true,
    dataCollection: true,
    marketingEmails: false,
    pushNotifications: true
  });

  const handleToggle = (key) => {
    setSettings(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleSave = () => {
    // TODO: Save to backend
    toast({
      title: '¡Configuración guardada!',
      description: 'Tus preferencias de privacidad han sido actualizadas',
    });
  };

  const PrivacySetting = ({ label, description, value, onChange }) => (
    <div className="flex items-start justify-between py-4 border-b last:border-0">
      <div className="flex-1 pr-4">
        <div className="font-medium mb-1">{label}</div>
        <div className="text-sm text-gray-500">{description}</div>
      </div>
      <Switch
        checked={value}
        onCheckedChange={onChange}
      />
    </div>
  );

  return (
    <div className="space-y-6">
            <Card className="p-6">
              <div className="flex items-center space-x-3 mb-6">
                <Eye className="w-8 h-8 text-zl-orange" />
                <h1 className="text-2xl font-bold">Privacidad</h1>
              </div>
              
              <div className="space-y-6">
                {/* Profile Visibility */}
                <div>
                  <h3 className="font-semibold text-lg mb-4">Visibilidad del perfil</h3>
                  <Card className="p-4">
                    <PrivacySetting
                      label="Perfil público"
                      description="Permite que otros usuarios vean tu perfil y actividad"
                      value={settings.profileVisible}
                      onChange={() => handleToggle('profileVisible')}
                    />
                    <PrivacySetting
                      label="Mostrar email"
                      description="Tu dirección de email será visible en tu perfil público"
                      value={settings.showEmail}
                      onChange={() => handleToggle('showEmail')}
                    />
                    <PrivacySetting
                      label="Mostrar teléfono"
                      description="Tu número de teléfono será visible en tu perfil"
                      value={settings.showPhone}
                      onChange={() => handleToggle('showPhone')}
                    />
                    <PrivacySetting
                      label="Mostrar historial de compras"
                      description="Las valoraciones y reseñas que hagas serán públicas"
                      value={settings.showPurchaseHistory}
                      onChange={() => handleToggle('showPurchaseHistory')}
                    />
                  </Card>
                </div>

                {/* Communication */}
                <div>
                  <h3 className="font-semibold text-lg mb-4">Comunicación</h3>
                  <Card className="p-4">
                    <PrivacySetting
                      label="Permitir mensajes"
                      description="Otros usuarios podrán enviarte mensajes directos"
                      value={settings.allowMessages}
                      onChange={() => handleToggle('allowMessages')}
                    />
                    <PrivacySetting
                      label="Mostrar estado en línea"
                      description="Mostrar cuando estás conectado a la plataforma"
                      value={settings.showOnlineStatus}
                      onChange={() => handleToggle('showOnlineStatus')}
                    />
                    <PrivacySetting
                      label="Emails de marketing"
                      description="Recibir ofertas, novedades y promociones por email"
                      value={settings.marketingEmails}
                      onChange={() => handleToggle('marketingEmails')}
                    />
                    <PrivacySetting
                      label="Notificaciones push"
                      description="Recibir notificaciones en el navegador"
                      value={settings.pushNotifications}
                      onChange={() => handleToggle('pushNotifications')}
                    />
                  </Card>
                </div>

                {/* Data & Privacy */}
                <div>
                  <h3 className="font-semibold text-lg mb-4">Datos y privacidad</h3>
                  <Card className="p-4">
                    <PrivacySetting
                      label="Recopilación de datos"
                      description="Permitir la recopilación de datos de uso para mejorar la experiencia"
                      value={settings.dataCollection}
                      onChange={() => handleToggle('dataCollection')}
                    />
                  </Card>
                  
                  <div className="mt-4 space-y-3">
                    <Card className="p-4 bg-yellow-50 border-yellow-200">
                      <div className="flex items-start space-x-3">
                        <Shield className="w-5 h-5 text-yellow-600 mt-1" />
                        <div>
                          <p className="font-medium text-yellow-900 mb-1">
                            Descargar tus datos
                          </p>
                          <p className="text-sm text-yellow-700 mb-3">
                            Obtén una copia de todos tus datos almacenados en Zona Libre.
                          </p>
                          <Button variant="outline" size="sm" className="bg-white">
                            Solicitar datos
                          </Button>
                        </div>
                      </div>
                    </Card>

                    <Card className="p-4 bg-red-50 border-red-200">
                      <div className="flex items-start space-x-3">
                        <EyeOff className="w-5 h-5 text-red-600 mt-1" />
                        <div>
                          <p className="font-medium text-red-900 mb-1">
                            Eliminar cuenta
                          </p>
                          <p className="text-sm text-red-700 mb-3">
                            Eliminar permanentemente tu cuenta y todos tus datos. Esta acción no se puede deshacer.
                          </p>
                          <Button variant="outline" size="sm" className="bg-white text-red-600 border-red-300">
                            Eliminar cuenta
                          </Button>
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>

                <Button
                  onClick={handleSave}
                  className="bg-zl-orange hover:bg-zl-orange-600"
                >
                  Guardar preferencias
                </Button>
              </div>
            </Card>
    </div>
  );
};

export default Privacy;
